import { Link } from '@tanstack/react-router'

/** Points curious founders at the qualitative side of their numbers. */
export function FeedbackHintBar({ startupId }: { startupId: string }) {
  return (
    <div className="flex items-center gap-2.5 rounded-lg border border-border bg-card2 px-3.5 py-2.5 text-xs text-muted-foreground">
      <span>
        Want to know why investors read what they read?{' '}
        <Link
          to="/app/startup/$id/profile/deep-insights"
          params={{ id: startupId }}
          className="font-semibold text-primary hover:underline"
        >
          Investor's Feedback
        </Link>{' '}
        has the qualitative side.
      </span>
    </div>
  )
}
